import { get } from "@/services/request";
import { statesAPI, countriesAPI } from "@/services/api";

// initial state
const state = {
  states: [],
  countries: []
};

// mutations
const mutations = {
  setStates(state, value) {
    state.states = value;
  },
  setCountries(state, value) {
    state.countries = value;
  }
};

// actions
const actions = {
  loadConstants({ commit }) {
    get(statesAPI)
      .then(response => {
        if (response && response.data) {
          commit("setStates", response.data);
        }
      })
      .catch(err => console.error("Error setting states", err));

    get(countriesAPI)
      .then(response => {
        if (response && response.data) {
          commit("setCountries", response.data);
        }
      })
      .catch(err => console.error("Error setting countries", err));
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
